import Grid from '@zenbusiness/zui/Grid';
import { superstyled } from '@zenbusiness/zui/styles';

export const StockFeeBreakdownGrid = superstyled({
  tag: Grid,
  name: 'ChargesTable',
  slot: 'StockFeeBreakdownGrid',
  styles: { paddingTop: '1.875rem' },
});
